<svelte:options tag={null} />
<script>
  import { get_current_component } from "svelte/internal";
  import "@everymatrix/em-accordion";

  export let success = false;
  export let error;
  let validationError;

  let limits = {
    seconds: 0
  }

  const thisComponent = get_current_component();

  const dispatchWcEvent = (name, detail) => {
    thisComponent.dispatchEvent(
      new CustomEvent(name, {
        detail,
        composed: true, // propagate across the shadow DOM
      })
    );
  };

  const handleData = (list) => {
    validationError = null;
    
    if (list.seconds === 0) {
      validationError = "Seconds must be greater than zero";
      return;
    } else {
      // Reset Selections
      limits = {
        seconds: 0
      }
      // Send Custom Event
      dispatchWcEvent("change", { "sessionLimit": list.seconds });
    }
  };
</script>


<div class="accordion">
  <em-accordion>
    <!-- Title -->
    <h3 slot="title" class="accordion__title">
      Session Limit
    </h3>
    <!-- Content -->
    <div slot="content" class="accordion__content">
      <!-- Limit Input -->
      <label class="inputWrapper">
        <span style="display: block; margin-bottom: 20px;">
          Seconds
        </span>
        <input
        class="input"
        type="number" 
        name="" 
        bind:value="{limits.seconds}"
        >
        <span>seconds</span>
      </label>
      {#if validationError}
        <p style="color: red;">
          {validationError}
        </p>
      {/if}
      {#if success?.hasOwnProperty('sessionLimit')}
        <p style="color: green;">
          Limit saved succesfully
        </p>
      {/if}
      <!-- 
        NOTE: Needed the request name because it conflicts with Cummulative Session 
      -->
      {#if error && error.includes('SetUserRgSessionLimitRequest')}
        <p style="color: red;">
          {error.slice(0, 23)}
        </p>
      {/if}
      <!-- Save Button -->
      <button
        class="button" 
        on:click={() => handleData(limits)}
      >
        Save
      </button>
    </div>
  </em-accordion>
</div>


<style lang="scss">
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    list-style: none;
    outline: none;
    text-decoration: none;
    box-sizing: border-box;
    font-family: "Helvetica Neue", "Helvetica", sans-serif;
  }
  .accordion {
    margin-bottom: 10px;

    &__content {
      display: flex;
      flex-direction: column;
    }
  }

  .inputWrapper {
    margin-bottom: 10px;
    span { font-weight: bold; }
  }

  .input {
    max-width: 50%;
    padding: 5px 10px;
    margin-right: 10px;
  }

  .button {
    display: block;
    width: 150px;
    margin: 20px auto 0 auto;
    min-height: 30px;
    padding: 6px 7px;
    color: #fff;
    background: #307fe2;
    border: 1px solid #307fe2;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 16px;
    &:hover {
      background: #000;
      border: 1px solid #000;
    }
  }
</style>
